<template>
  <div>
    <el-row v-for="post in postList" :key="post.id" class="postInfo">
      <el-col :lg="20" :xs="17">
        <el-row class="p-first"
          ><el-col :span="24"
            ><el-link
              :underline="false"
              class="content-break"
              type="primary"
              @click="gotoPost(post.id)"
              ><span class="name">{{ post.name }}</span
              ><span class="science">{{
                scienceValFormat(post.science)
              }}</span></el-link
            ></el-col
          ></el-row
        >
        <el-row class="p-second"
          ><span class="careerRequire">{{ post.careerRequire }}</span
          ><span class="eduRequire">{{
            eduRequireFormat(post.eduRequire,post.eduRequireAndOver)
          }}</span>
          <span class="requireNum">{{
            post.requireNum > 0 ? post.requireNum : "人数不限"
          }}</span></el-row
        >
        <el-row class="p-third">
          <span class="publishDate">{{ dateFormat(post.publishDate) }}</span> 至
          <span class="endDate">{{ dateFormat(post.endDate) }}</span>
        </el-row>
      </el-col>
      <el-col :lg="2" :xs="{ span: 3, offset: 1 }">
        <a @click="gotoResume(post)">
          <div class="postCount">
            {{ post.postCount ? post.postCount : 0 }} <br /><span>投递</span>
          </div>
        </a>
      </el-col>
      <el-col :lg="2" :xs="3">
        <div class="viewCount">
          {{ post.viewCount ? post.viewCount : 0 }} <br /><span>浏览</span>
        </div>
      </el-col>
    </el-row>
    <el-row><div class="rowLine"></div></el-row>
  </div>
</template>

<script>
import { searchBasicData } from "@api/framework/basicData/dataDictType";
import { mapGetters } from "vuex";
import { isArray } from "zr-util/src/utils/comm/validate";
import commFormat from "zr-util/src/utils/comm/commFormat";
export default {
  name: "PostList",
  props: {
    postList: {
      type: Array,
      default() {
        return [];
      },
      require: true,
    },
  },
  data() {
    return {
      scienceArray: [],
      eduTypeArray: [],
    };
  },
  computed: {
    ...mapGetters({
      curRole: "user/curRole",
    }),
  },
  async created() {
    await this.initScienceType();
    await this.getEduTypeArray();
  },
  methods: {
    async initScienceType() {
      const res = await searchBasicData({ typeCode: "scienceType" });
      if (res.success) {
        this.scienceArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //学历要求
    async getEduTypeArray() {
      let res = await searchBasicData({ typeCode: "eduRequire" });
      if (res.success) {
        this.eduTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    gotoPost(id) {
      this.$router.push({
        path: "/positionView/index",
        query: { positionInfoId: id },
      });
    },
    gotoResume(post) {
      if (this.curRole == "user" || this.curRole == "anonymous") {
      } else {
        this.$router.push({
          path: "/resumeManagement/index",
          query: {
            positionInfoId: post.id,
          },
        });
      }
    },
    scienceValFormat(value) {
      let jsonData = [];
      try {
        jsonData = JSON.parse(value);
      } catch (error) {
        if (value.indexOf(",") > 0) {
          jsonData = value.split(",");
        } else {
          jsonData = value;
        }
      }

      if (isArray(jsonData)) {
        const result = jsonData.map((data) => {
          const res = this.scienceArray.filter((val) => val.code == data);
          if (res && res.length > 0) {
            return res.map((value1) => value1.name).join(",");
          } else {
            return data;
          }
        });
        if (result && result.length > 0) {
          return result.join(",");
        }
      } else if (typeof jsonData == "string") {
        const result = this.scienceArray.filter((val) => val.code == jsonData);
        if (result && result.length > 0) {
          return result.map((value1) => value1.name).join(",");
        }
      }
      return jsonData;
    },
    eduRequireFormat(value,over) {
      const result = this.eduTypeArray.filter((val) => val.code == value);
      const isover =over===0?"":"及以上" ;
      return result[0] ? result[0].name+isover : value+isover;
    },
    dateFormat(value) {
      if (value && typeof value == "string") {
        return value.substr(0, 10);
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.postInfo {
  min-height: 80px;
  table-layout: fixed;
  position: relative;
  overflow: hidden;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 12px;
  color: #606266;

  .p-first,
  .p-second,
  .p-third {
    margin-top: 5px;
  }

  .science,
  .eduRequire,
  .requireNum {
    margin-left: 20px;
  }
  .name {
    font-weight: bold;
  }

  .postCount,
  .viewCount {
    position: relative;
    height: 100%;
    text-align: center;
    font-size: 30px;
    //font-weight: bold;
    color: #44aaee;

    span {
      font-size: 12px;
      color: #44aaee;
    }
  }
}

.postInfo:nth-child(odd) {
  background-color: #fafafa;
}

.postInfo:nth-child(even) {
  background-color: #ffffff;
}

.content-break {
  white-space: pre-wrap;
  display: block;
  word-wrap: break-word;
  overflow: hidden;
}

@mixin row-line {
  content: " ";
  height: 1px;
  width: 100%;
  background-color: #ebeef5;
}

.postInfo:before {
  @include row-line;
}

.rowLine {
  @include row-line;
}
</style>
